export const MATERIALS_CATEGORY_ID = 3000
export const TOOLS_CATEGORY_ID = 4000